import { MCSA0525CollGroupId } from "respondent_config_generator/src/projects/MSCA-0525";
import { PlatformInstructionsKey } from "../../LandingPage/Components/Steps/LoginAndCompletionCode";
import { LandingPageConfigBuilder } from "../../LandingPage/landingPageConfigBuilder";
import { CAIParams } from "../../queryParams";
import { setCurrentLang } from "../../i18n";
import { AppLanguage, getLanguageStrings } from "internationalisation";

const getPlatform = (groupId: MCSA0525CollGroupId): PlatformInstructionsKey => {
	switch (groupId) {
		case "MCSA-443-0525-GROUP1-FACEBOOK":
		case "MCSA-444-0525-GROUP2-FACEBOOK":
			return "facebook";

		case "MCSA-445-0525-GROUP1-YOUTUBE":
		case "MCSA-446-0525-GROUP2-YOUTUBE":
			return "youtube";

		case "MCSA-447-0525-GROUP1-TIKTOK":
		case "MCSA-448-0525-GROUP2-TIKTOK":
			return "tiktok";
		
		case "MCSA-449-0525-GROUP1-INSTAGRAM":
		case "MCSA-450-0525-GROUP2-INSTAGRAM":
			return "instagram";

		case "MCSA-451-0525-GROUP1-YAHOO":
		case "MCSA-452-0525-GROUP2-YAHOO":
			return "yahoo-mobile";

		default:
			assertNever(groupId);
	}
}

export const configureMCSA0525Page = (
	landingPageBuilder: LandingPageConfigBuilder,
	params: CAIParams<MCSA0525CollGroupId>
) => {
	setCurrentLang(AppLanguage.en);

	landingPageBuilder.setSteps(
		LandingPageConfigBuilder.getStandardViewingSurveySteps(
			getPlatform(params.G)
		)
	);

	landingPageBuilder.setPageTitle(
		getLanguageStrings(AppLanguage.en).LandingPage.Title
	)
}